<script>
import {defineComponent} from 'vue'
import axios from "axios";
import {toast} from "vue3-toastify";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";
export default defineComponent({
  name: "lesson-instance",
  mixins: [modalKkMixin],
  props: ['lesson', 'instance', 'admin', 'current_user'],
  data() {
    return {
      showM: false,
      date: (this.instance ? this.instance.day : new Date().toISOString().split('T')[0]),
      lesson_students: [],
      desc:''
    }
  },
  watch: {


    'lesson.id': {
      handler(newVal, oldVal) {
        console.log('watch: lesson object changed', { oldVal, newVal })
        this.loadStudents()
      },
      deep: true,
      immediate: true
    },
    instance: {
      handler(newVal, oldVal) {
        console.log('watch: instance object changed', { oldVal, newVal })
        this.date = (newVal ? newVal.day : new Date().toISOString().split('T')[0])
        this.desc = (newVal ? newVal.description : '')
        this.loadStudents()
      },
      deep: true,
      immediate: true
    }

  },
  methods: {
    dayName(day) {
      return ['Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek'][day - 1] || '';
    },
    hourFormat(hour) {
      return hour ? `${hour}:00` : '';
    },
    // Nahraď metodu v `app/javascript/components/onlajnovka/lesson-instance.vue`

    async loadStudents() {
      console.log('Načítám studenty pro lekci', this.lesson)
      const id = this.lesson && this.lesson.id
      if (!id) {
        console.warn('loadStudents: lesson id chybí')
        return
      }

      try {
        const response = await axios.get(`/onlajnovka/lessons/${id}/students`, {
          params: { instance_id: this.instance ? this.instance.id : null }
        })
        const items = (response.data && response.data.items) || []
        // nastavíme present bezpečně a neměníme původní objekty nečekaně
        this.lesson_students = items.map(s => ({...s, present: !!s.present}))

      } catch (err) {
        console.error('Chyba při načítání studentů:', err)
        toast.error('Nepodařilo se načíst studenty')
      }
    },

    saveLessonInstance() {


      const data = {
        lesson_instance: {
          lesson_id: this.lesson.id,
          description: this.desc,
          date: this.date, // Příklad: dnešní datum
          students: this.lesson_students.map(s => ({id: s.id, present: s.present}))
        }
      }

      if (this.instance && this.instance.id) {
        const url = `/onlajnovka/lessons/${this.lesson.id}/lesson-instance/${this.instance.id}`

        axios.put(url, data).then(response => {
          console.log('Lesson instance updated:', response.data)
          toast.success("Lekce uložena")
          this.hideModal()
          this.$emit('lessonSaved')
        }).catch(error => {
          console.error('Chyba při ukládání lekce:', error)
          const msg = (error.response && error.response.data && error.response.data.message) || 'Nepodařilo se uložit lekci'
          this.$emit('lessonSaved')
          toast.error(msg)
        })

      }else {
        const url = `/onlajnovka/lessons/${this.lesson.id}/lesson-instance`


        axios.post(url, data).then(response => {
          console.log('Lesson instance saved:', response.data)
          toast.success("Lekce uložena")
          this.hideModal()
          this.$emit('lessonSaved')
        }).catch(error => {
          console.error('Chyba při ukládání lekce:', error)
          const msg = (error.response && error.response.data && error.response.data.message) || 'Nepodařilo se uložit lekci'
          this.$emit('lessonSaved')
          toast.error(msg)
        })
      }
    }
  }

})


/*
tlačítko Zaznamenat lekci (nové) - popup okno - bude stejné jako když Admin stiskne Upravit, ale lektor uvidí vše uzamčené a needitovatelné
- přidají se tam lektorovi 2 věci, které jediné může editovat a to:
1) DATUM: zadání data lekce - přesný datum dané lekce - kdy proběhla
2) přítomnost na lekci - u seznamu e-mailových adres studentů zaškrtávací políčko, kde lektorka vyškrtá kdo byl přítomný na lekci - zaškrtnuté znamená byl na lekci, nezaškrtnuté - nebyl na lekci. Defaultně odšrtat všechna a dát jako povinné pole, aby to lektorka nezapomínala zaškrtat - nepůjde jí to uložit pokud nezašrtne alespoň jednoho ze studentů
3) tlačítko Uložit odučenou lekci - to uloží lekci do sekce Lekce kterou vidí admin i lektor a lekce bude ve stavu inserted (obdobně jako je to u Konverzačního klubu)
*/
</script>

<template>
<vue-final-modal v-model="showM" classes="modal-container " content-class="modal-content-f mcw1">

    <div class="modal-header">
      <span class="modal__title"> {{ instance && instance.id ? 'Upravit lekci' : 'Zaznamenat lekci'}}
      </span>
      <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal__content">

      <div class="row">
        <div class="col-md-6">
          <div v-if="lesson">
            <p><strong>Semestr:</strong> {{ lesson.semester_name ? lesson.semester_name : 'N/A' }}</p>
            <p><strong>Úroveň:</strong> {{ lesson.level_name || 'N/A' }}</p>
            <p><strong>Lektor:</strong> {{ lesson.lector_name ? `${lesson.lector_name} ` : 'N/A' }}  </p>
            <p v-if="lesson.lector_id != current_user.id"><strong>Záskok:</strong> {{current_user.name}}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div v-if="lesson">
            <p><strong>Čas:</strong> {{ hourFormat(lesson.hour) }}</p>
            <p><strong>Den:</strong> {{ dayName(lesson.day) }}</p>
            <p><strong>Kapacita:</strong> {{ lesson.capacity }}</p>
          </div>
        </div>

        <hr>

        <div class="col-md-12">
          <b>Datum</b>
          <input type="date" class="form-control col-md-3 mb-3" v-model="date" />
        </div>


        <div class="col-md-12">
          <b>Description</b>
          <textarea v-model="desc" class="form-control" style="min-height: 150px"/>
        </div>

        <div class="col-md-12">

          <table class="table table-striped">
            <thead>
              <tr>
                <th colspan="2">Student</th>
                <th>Přítomnost na lekci</th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="student in lesson_students" :key="student.id">
                <td>
                  <img :src="student.profile_image_url"  alt="" class="rounded-circle" width="30" height="30" v-if="student.profile_image_url" />
                  <img :src="`/img/OJ_onlajnovka_logo_svetle-1.png`" alt="Default Profile" class="rounded-circle" width="30" height="30" v-else/>
                  {{ student.name }} {{ student.surname }}
                </td>
                <td>{{ student.email }}</td>
                <td>
                  <input type="checkbox" v-model="student.present" />
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>



  <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="hideModal">Zavřít</button>

    <button type="button" class="btn btn-primary" @click.prevent="saveLessonInstance">
    Uložit odučenou lekci
    </button>

    </div>
</vue-final-modal>
</template>

<style scoped>

</style>